import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const getAuthState = createSelector(
  (state: RootState) => state,
  ({ auth }) => auth
);

export const getExamState = createSelector(
  (state: RootState) => state,
  ({ exam }) => exam
);

export const getProductState = createSelector(
  (state: RootState) => state,
  ({ product }) => product
);

export const getCommonState = createSelector(
  (state: RootState) => state,
  ({ common }) => common
);

export const getRequestState = createSelector(
  (state: RootState) => state,
  ({ request }) => request
);
export const getSupportState = createSelector(
  (state: RootState) => state,
  ({ support }) => support
);

export const getVoucherState = createSelector(
  (state: RootState) => state,
  ({ voucher }) => voucher
);

export const getAnnouncementState = createSelector(
  (state: RootState) => state,
  ({ announcement }) => announcement
);

export const getUserState = createSelector(
  (state: RootState) => state,
  ({ user }) => user
);
export const getExaminerState = createSelector(
  (state: RootState) => state,
  ({ examiner }) => examiner
);

export const getFinanceState = createSelector(
  (state: RootState) => state,
  ({ finance }) => finance
);
export const getCategoryState = createSelector(
  (state: RootState) => state,
  ({ category }) => category
);

export const getAtcState = createSelector(
  (state: RootState) => state,
  ({ atc }) => atc
);
